export const UPDATE_ORDER_ITEMS = 'UPDATE_ORDER_ITEMS';
export const UPDATE_MENU_ITEMS = 'UPDATE_MENU_ITEMS';
export const UPDATE_ORDER_TOTAL = 'UPDATE_ORDER_TOTAL';
